import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div<{ barColor?: string }>`
  flex: 1;
  height: ${({ theme: { spacing } }) => spacing(1)};
  background-color: ${({ barColor, theme: { color } }) => (barColor ? barColor : color.borderGray)};
`;

const InnerContainer = styled.div<{ valuePercent: number; fillColor?: string }>`
  height: 100%;
  background-color: ${({ fillColor, theme: { color } }) => (fillColor ? fillColor : color.validationGreen)};
  width: ${({ valuePercent }) => `${valuePercent}%`};
`;

type ProgressLineProps = {
  valuePercent: number;
  barColor?: string;
  fillColor?: string;
};

export const ProgressLine: FC<ProgressLineProps> = ({ valuePercent, fillColor, barColor }) => {
  return (
    <Container barColor={barColor}>
      <InnerContainer valuePercent={valuePercent} fillColor={fillColor} />
    </Container>
  );
};
